import { newInvariantError } from "../../utilities/globals/index.js";
export var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === "undefined") {
        throw newInvariantError(40);
    }
};
//# sourceMappingURL=checkFetcher.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/link/http/checkFetcher.js
// module id = 1105
// module chunks = 11